import './styles.scss'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import Button from '../Button'
import Icon from '../../Icon'

const Select = (props) => {
  const classNames = ['Select']
  if (props.type) {
    classNames.push('Select-' + props.type)
  }

  let label = ''
  if (props.label !== undefined) {
    label = <label>{props.label + (props.required ? ' *' : '')}</label>
  }

  let message
  if (props.valid !== true) {
    if (props.message) {
      message = <span>{props.message}</span>
    }
    classNames.push('SelectError')
  }

  const options = props.options
  if (props.placeholder !== '' && !props.selected) {
    options.unshift({ value: '', label: props.placeholder })
  }

  const value = (props.selected === null || props.selected === undefined) ? '' : props.selected
  let hasHiddenOption = true
  const optionComponents = options.map((option) => {
    const optionValue = props.optionValueKey ? get(option, props.optionValueKey, undefined) : option.value
    if (typeof option.value === 'undefined' || option.value === '' || option.value === null) {
      hasHiddenOption = false
    }
    const optionLabel = props.optionLabelKey ? get(option, props.optionLabelKey, '?') : option.label
    return (
      <option
        value={optionValue} key={optionValue}
      >{optionLabel}</option>
    )
  })

  return (
    <div>
      {label} {message}
      <div className={'select-wrap'}>
        <select className={classNames.join(' ')}
                disabled={props.disabled}
                value={value}
                onChange={props.onChange}>
          {hasHiddenOption && <option disabled hidden value={null}/>}
          {optionComponents}
        </select>
        {props.clearable && value !== '' &&
          <Button classNames={'Button-Select-Append'} onClick={props.onClear}>
            <Icon type={'fa'} faClassName={'fa-remove'}/></Button>}
      </div>
    </div>
  )
}

Select.defaultProps = {
  placeholder: '',
  required: false,
  disabled: false,
  valid: true,
}

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  onClear: PropTypes.func,
  selected: PropTypes.any,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  valid: PropTypes.bool,
  clearable: PropTypes.bool,
  message: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  optionLabelKey: PropTypes.any,
  optionValueKey: PropTypes.any,
}

export default Select
